import cscRegistry from "./store/CSCRegistry";
import cscAnswer from "./store/CSCAnswer";
import cscCustomAnswer from "./store/CSCCustomAnswer";
import cscFormAnAnswer from "./store/CSCFormAnAnswer";
import cscFormAnAnswer060X0001 from "./store/CSCFormAnAnswer060X0001";
import cscRejection from "./store/CSCRejection";
import cscInvoice from "./store/CSCInvoice";
import cscComment from "./store/CSCComment";
import cscContractInfo from "./store/CSCContractInfo";
import cscConfirmReception from "./store/CSCConfirmReception";
import cscPrepareConclusion from "./store/CSCPrepareConclusion" 


const dialogs = {
    namespaced: true,
    state: {
        answerWithAddress: ["01040015", "01040016", "01040054", "01040055", "01040056", "01040044", "01030023", "01030024", "01030020", "01050015", "01170003", "01180002", "01090001", "01090003", "01090006", "01190001"]
    },
    actions: {

    },
    modules: {
        cscRegistry,
        cscAnswer,
        cscCustomAnswer,
        cscFormAnAnswer,
        cscFormAnAnswer060X0001,
        cscRejection,
        cscInvoice,
        cscComment,
        cscContractInfo,
        cscConfirmReception,
        cscPrepareConclusion
    },
    getters: {
        answerWithAddress: (s) => s.answerWithAddress
    }   
}

export default dialogs;